import {
  activeVariantConfig,
  broadcaster,
  cmp,
  CONSENT_CHANGED_BROADCAST_EVENT,
  environmentConfig,
  featureToggles,
  logger,
  retryBackoffStrategy,
  showConsentBannerUseCase,
} from '@otto-ec/eprivacy-shared'

import { ConsentProviderPort } from './ports'
import {
  informClientOnConsentChanged,
  isOneTrustEnabled,
  isOneTrustInternalHostingEnabled,
  isOneTrustLazyLoadingEnabled,
} from './core'
import { loadOneTrustConsentProviderFactory, onetrustConfig } from './adapters'

export const RETRY_CONFIG = [0, 200, 300, 500, 2500]

export async function bootstrap(): Promise<ConsentProviderPort | undefined> {
  showConsentBannerUseCase.hideInitial()

  if (!isOneTrustEnabled(featureToggles)) {
    logger.info('OneTrust is not enabled')
    return
  }
  const internalHosting: boolean =
    isOneTrustInternalHostingEnabled(featureToggles)
  const loadOnetrustConsentProvider = loadOneTrustConsentProviderFactory(
    logger,
    environmentConfig,
    internalHosting,
    retryBackoffStrategy(RETRY_CONFIG),
    isOneTrustLazyLoadingEnabled(featureToggles)
  )
  const variantConfig = await activeVariantConfig()
  const consentProvider = await loadOnetrustConsentProvider(
    onetrustConfig(environmentConfig),
    variantConfig.onetrustVariantId
  )

  /*                                                              */
  consentProvider.OnConsentChanged(async () => {
    await informClientOnOnetrustConsentChange(consentProvider)
  })

  broadcaster.receive(
    CONSENT_CHANGED_BROADCAST_EVENT,
    async () => await cmp.emitConsentChangeEvent()
  )

  return consentProvider
}

async function informClientOnOnetrustConsentChange(
  consentProvider: ConsentProviderPort
) {
  try {
    await informClientOnConsentChanged(consentProvider, cmp, broadcaster)
  } catch (error) {
    logger.error(
      new Error(`Could not inform client on consent change`, { cause: error })
    )
  }
}
